export default __webpack_public_path__ + "static/media/blagovesta.b1c2de85.png";